export default __webpack_public_path__ + "CircularCustCapNum-BoldItalic.4b4d775ba6705179a31f45aa3cdcc42f.eot";